import { containerStyles } from "./container.styles";
import { ContainerProps } from "./container.types";

export const Container: React.FC<ContainerProps> = (props) => {
  const { className, children, grid = false, as, ...rest } = props;

  const styles = containerStyles({ className, grid });

  const Component = as ?? "section";

  return (
    <Component className={styles} {...rest}>
      {children}
    </Component>
  );
};
